import Index from '@tunnel-components/@pages/supervision/systems/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/systems/home/index.ts